import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import whatsappTemplates from './whatsappTemplates/whatsappTemplates.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import leadScore from './lead-score/leadScore.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import correio from './correio/correio.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import captain from './captain/captain.routes';
import appointments from './appointments/appointments.routes';
// Whitelabel Vue routes intentionally NOT imported — see commit eb9d9a8ee3.
// Backend `/super_admin/whitelabel/*` requires Devise SuperAdmin scope (separate
// from User scope), so XHR from /app/ session returns 401. Use the canonical
// Rails-side panel at /super_admin/whitelabel (7 abas: Editor, Branding,
// Login, Email, Preview & Análise, Templates, Export/Import).
//
// The Vue components in routes/dashboard/settings/whitelabel/ are kept refactored
// (i18n keys, eslint clean) as profilactic for future migration if/when a
// cross-scope auth bridge is added.
// import whitelabel from './whitelabel/whitelabel.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...whatsappTemplates.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...leadScore.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...correio.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
    ...appointments.routes,
    // ...whitelabel.routes — see comment above the import at top of file.
  ],
};
